import {
  GetCatalogProductDetailPageOption_pdp_option_info_catalog_product as ProductOptionInfo,
  GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_additional_item_list as AdditionalItemList,
  GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_custom_input_option_list as OriginTextOption,
  GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matched_item_list as ProductItem,
  GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_matching_catalog_product_info as MatchingProductOptionInfo,
  GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_additional_option_list as AdditionalOptionList,
  GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_option_list as ProductOptionList,
  GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_product_option_list_value_list as OptionValueList,
  GetCatalogProductDetailPageOption_pdp_option_info_catalog_product_promotion_info_bogo_info as BogoInfo,
  PdpDeliveryType,
} from '../graphql/select-option_types.2';

export type { BogoInfo, ProductItem };

export enum OptionType {
  BASIC = 'BASIC',
  ADDITIONAL = 'ADDITIONAL',
}

export type ItemCardType = {
  item: SelectedItem;
  disableCounter: boolean;
  optionNames: string;
  minCount: number;
  maxCount: number;
  count: number;
  is_bogo: boolean;
  is_zigzin: boolean;
  product_id: string;
  bogo_required_quantity?: number | null;
};

export type ItemListMapValueType = Pick<
  ProductItem,
  | 'display_status'
  | 'sales_status'
  | 'final_price'
  | 'remain_stock'
  | 'delivery_type'
  | 'expected_delivery_date'
  | 'price'
>;

export type CustomOptionValueList = OptionValueList & {
  is_zigzin?: boolean;
  is_last_option?: boolean;
  is_free_shipping?: boolean;
  shipping_fee?: number;
};

export type CustomProductOptionList = Omit<ProductOptionList, 'value_list'> & {
  value_list: CustomOptionValueList[];
};

export type CustomMatchingProductInfo = Omit<MatchingProductOptionInfo, 'option_list'> & {
  option_list: CustomProductOptionList[];
};

export interface CustomOptionsInfo
  extends Omit<
    ProductOptionInfo,
    'product_option_list' | 'matching_catalog_product_info' | 'matched_item_list' | 'shipping_fee'
  > {
  product_option_list: CustomProductOptionList[];
  matching_catalog_product_info: CustomMatchingProductInfo | null;
  matched_item_list: ProductItem[];
}

export interface SelectedOption extends CustomProductOptionList {
  selected_value: string;
  selected_value_id: string;
  is_zigzin: boolean;
}

export interface CustomAdditionalOptionList extends AdditionalOptionList {
  item_list: AdditionalItemList[];
}

export interface CustomTextOption extends OriginTextOption {
  selected_value: string;
}

export interface OptionValue {
  id: string;
  value: string;
  sold_out: boolean;
  code: string | null;
  image_url: string | null;
  webp_image_url: string | null;
  notification_info?: NotificationInfo | null;
  remain_stock?: number | null;
  delivery_type: PdpDeliveryType | null;
  hasRemainStock?: boolean;
  price?: number;
  origin_price?: number;
}

export interface SelectedItem extends ProductItem {
  count: number;
  options: SelectedOption[][];
  text_options: CustomTextOption[][];
  origin_items: ProductItem[];
  option_type?: string | null;
  is_bogo?: boolean;
  isFastShipping?: boolean;
}

export interface SelectedItemMap {
  [key: string]: SelectedItem;
}

export interface NotificationInfo {
  product_item_id: string;
  active: boolean;
}

export interface RestockNotificationInfo {
  product_item_id: string;
  active: boolean;
}

export type RestockNotificationStatus = 'succeeded' | 'failed' | null;
